var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { postLogoutPressMessage } from '~utils/postLogoutPressMessage';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        console.log('crash error: ', error);
        console.log('crash error-info: ', errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.props, children = _a.children, errorScreen = _a.errorScreen;
        var onClick = function () {
            if (window.isWebView) {
                postLogoutPressMessage();
            }
            else {
                window.location.href = '/';
            }
        };
        return this.state.hasError
            ? React.cloneElement(errorScreen, { click: onClick })
            : children;
    };
    return ErrorBoundary;
}(React.Component));
export default ErrorBoundary;
